module.exports = __webpack_public_path__ + "media/assets/logoNavBar-7c47103f187d17ab86cc0f352de2582e.png";